<template>
    <section class="pt-10" id="destination" style="background: #f8f9fa;">
        <div class="container my-5">
            <h1 class="text-center mb-5">API Guide for Standard Packages</h1>

            <!-- Standard Package API -->
            <div class="api-section mb-5">
                <h2>Standard Package API: <span class="text-muted">/api/user-standed</span></h2>

                <div class="card p-3 mb-4">
                    <h4>1. API Endpoint Overview</h4>
                    <div class="api-endpoint">
                        <strong>URL:</strong> `http://127.0.0.1:8000/api/user-standed` <br>
                        <strong>Method:</strong> `GET` <br>
                        <strong>Response:</strong> A list of places with standard package details.
                    </div>
                </div>

                <div class="card p-3 mb-4">
                    <h4>2. Making the API Request</h4>
                    <p><strong>Using Postman or Insomnia:</strong></p>
                    <ul>
                        <li>Open Postman or Insomnia.</li>
                        <li>Select the `GET` request method.</li>
                        <li>Enter the URL: <code>http://127.0.0.1:8000/api/user-standed</code></li>
                        <li>Click <strong>Send</strong> to make the request.</li>
                    </ul>

                    <p><strong>Using curl Command:</strong></p>
                    <pre><code>curl -X GET http://127.0.0.1:8000/api/user-standed</code></pre>
                </div>

                <div class="card p-3 mb-4">
                    <h4>3. Interpreting the Response</h4>
                    <div class="response-example">
                        <code>[
    {
      "id": 1,
      "placeName": "Sample Place 1",
      "fullTime": "yes",
      "slug": "sample-place-1",
      "placePhNo": "123456789",
      "email": "info@sample1.com",
      "coverImage": "https://example.com/images/cover1.jpg",
      "placeImages": "https://example.com/images/image1.jpg"
    }
  ]</code>
                    </div>
                </div>

                <div class="card p-3 mb-4">
                    <h4>4. Response Fields</h4>
                    <ul>
                        <li><strong>id:</strong> Unique identifier for the place.</li>
                        <li><strong>placeName:</strong> Name of the place.</li>
                        <li><strong>fullTime:</strong> Availability status (e.g., "yes" for full-time availability).
                        </li>
                        <li><strong>slug:</strong> SEO-friendly URL identifier.</li>
                        <li><strong>placePhNo:</strong> Phone number.</li>
                        <li><strong>email:</strong> Contact email.</li>
                        <li><strong>coverImage:</strong> URL of the cover image.</li>
                        <li><strong>placeImages:</strong> URL of the first place image.</li>
                    </ul>
                </div>

                <div class="card p-3 mb-4">
                    <h4>5. Handle API Response in Your Application</h4>
                    <pre><code>fetch('http://127.0.0.1:8000/api/user-standed')
    .then(response => response.json())
    .then(data => {
      console.log(data);  // Use the data in your app
    })
    .catch(error => console.error('Error:', error));</code></pre>
                </div>

                <div class="card p-3 mb-4">
                    <h4>6. API Authentication (If Needed)</h4>
                    <p><strong>Using Postman/Insomnia:</strong></p>
                    <ul>
                        <li>Go to <strong>Authorization</strong> tab.</li>
                        <li>Choose <strong>Bearer Token</strong> and add the token.</li>
                    </ul>

                    <p><strong>Using curl with Token:</strong></p>
                    <pre><code>curl -X GET \
    http://127.0.0.1:8000/api/user-standed \
    -H "Authorization: Bearer your_token_here"</code></pre>
                </div>

                <div class="card p-3 mb-4">
                    <h4>7. Troubleshooting</h4>
                    <ul>
                        <li><strong>500 Internal Server Error:</strong> Check your Laravel server and ensure it is
                            running correctly.</li>
                        <li><strong>404 Not Found:</strong> Verify the URL is correct.</li>
                        <li><strong>Unauthorized Error:</strong> Ensure the correct authentication token is being used.
                        </li>
                    </ul>
                </div>
            </div>

          
        </div>
    </section>
</template>

<script>
export default {
    name: 'ApiGuide',
};
</script>

<style scoped>
.api-section {
    margin-bottom: 40px;
}

.api-endpoint {
    background-color: #f8f9fa;
    padding: 10px;
    border-radius: 5px;
    margin-bottom: 10px;
}

.response-example {
    background-color: #f1f1f1;
    padding: 10px;
    border-radius: 5px;
    margin-top: 10px;
    font-family: monospace;
}
</style>